import React, { FunctionComponent } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled from 'styled-components/native'

import therapyImage from '../../assets/therapy.png'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

const ImageContainer = styled(Image)<{ size: string }>(({ size }) => ({
  width: size,
  height: size,
}))

/**
 * Illustration to show on the treatment card
 */
export const IndividualTherapy: FunctionComponent<IndividualTherapyProps> = ({ size = 124 }) => {
  const sizeInPixels = `${size}px`
  return (
    <ImageContainer
      size={sizeInPixels}
      testID={`${tID('IndividualTherapyIllustration')}`}
      source={therapyImage as ImageSourcePropType}
    />
  )
}

type IndividualTherapyProps = {
  size?: number
}
